var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, List, BooleanField, TextField, NumberField, ReferenceManyField, TextInput, BooleanInput, NumberInput, ReferenceField, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { ChipList } from "../../components/ChipList";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
var OMIT_FIELDS = [
    "id",
    "is_acclaimed",
    "is_active",
    "min_votes",
    "max_votes",
    "voting_type",
    "counting_algorithm",
    "is_encrypted",
];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Description", source: "description" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(BooleanInput, { label: "Is Acclaimed", source: "is_acclaimed" }, 3),
    _jsx(BooleanInput, { label: "Is Active", source: "is_active" }, 4),
    _jsx(NumberInput, { label: "Min Votes", source: "min_votes" }, 5),
    _jsx(NumberInput, { label: "Max Votes", source: "max_votes" }, 6),
    _jsx(TextInput, { label: "Voting Type", source: "voting_type" }, 7),
    _jsx(TextInput, { label: "Counting Algorithm", source: "counting_algorithm" }, 8),
    _jsx(BooleanInput, { label: "Is Encrypted", source: "is_encrypted" }, 9),
    _jsx(TextInput, { source: "election_event_id" }, 10),
    _jsx(TextInput, { source: "election_id" }, 11),
];
export var ListContest = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id", "election_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h5" }, { children: "Contests" })), _jsx(List, __assign({ actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: tenantId || undefined,
                }, filters: Filters, aside: aside }, { children: _jsxs(DatagridConfigurable, __assign({ rowClick: rowClickHandler, omit: OMIT_FIELDS }, { children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name" }), _jsx(TextField, { source: "description" }), _jsx(BooleanField, { source: "is_acclaimed" }), _jsx(BooleanField, { source: "is_active" }), _jsx(NumberField, { source: "min_votes" }), _jsx(NumberField, { source: "max_votes" }), _jsx(TextField, { source: "voting_type" }), _jsx(TextField, { source: "counting_algorithm" }), _jsx(BooleanField, { source: "is_encrypted" }), _jsx(ReferenceManyField, __assign({ label: "Candidates", reference: "sequent_backend_candidate", target: "contest_id" }, { children: _jsx(ChipList, { source: "sequent_backend_candidate", filterFields: ["election_event_id", "contest_id"] }) })), _jsx(ReferenceField, __assign({ source: "election_event_id", reference: "sequent_backend_election_event" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(ReferenceField, __assign({ source: "election_id", reference: "sequent_backend_election" }, { children: _jsx(TextField, { source: "name" }) }))] })) }))] }));
};
